import { Api } from '@/core/api.js'
const api = new Api()
import Vue from 'vue'

const state = {
    bills: {},
    billsKpis: { total_bills: 0, total_import: 0, total_customers: 0 },
    billsPagination: { total: 0, page: 1, limit: 20 },
    correctiveBills: {},
    correctiveBillsKpis: { total_bills: 0, total_import: 0, total_customers: 0 },
    correctiveBillsPagination: { total: 0, page: 1, limit: 20 },
    billsFilters: {},
    billsFiltersActive: {
        date: 'month',
        restaurants: 'admin.filters.all_restaurants',
        customers: 'admin.filters.all_customers'
    }
}

const getters = {
    getBills: (state) => (id) => {
        if (id) {
            return state.bills[id]
        }
        return state.bills
    },
    getBillsKpis: (state) => state.billsKpis,
    getBillsPagination: (state) => state.billsPagination,
    getCorrectiveBills: (state) => state.correctiveBills,
    getCorrectiveBillsKpis: (state) => state.correctiveBillsKpis,
    getCorrectiveBillsPagination: (state) => state.correctiveBillsPagination,
    getBillsFilters: (state) => state.billsFilters,
    getBillsFiltersActive: (state) => state.billsFiltersActive
}

const actions = {
    loadBills(context, params) {
        const payload = {
            ...params,
            page: params.page !== undefined ? params.page : 1,
            per_page: params.per_page !== undefined ? params.per_page : 20
        }
        return api
            .post(`admin/bill/list`, payload)
            .then((response) => {
                if (!response.status) return response
                const meta = response.meta || {}
                const kpis = response.kpis || { total_bills: 0, total_import: 0, total_customers: 0 }
                if (Array.isArray(response.data)) {
                    const itemsById = {}
                    response.data.forEach((item) => {
                        if (item && item.id != null) itemsById[item.id] = item
                    })
                    context.commit('setBills', itemsById)
                    context.commit('setBillsKpis', kpis)
                    context.commit('setBillsPagination', {
                        total: meta.total_bills ?? 0,
                        page: meta.page ?? 1,
                        limit: meta.per_page ?? 20,
                        total_pages: meta.total_pages ?? 0
                    })
                } else if (typeof response.data === 'object' && response.data !== null && !Array.isArray(response.data)) {
                    const arr = Object.values(response.data)
                    context.commit('setBills', response.data)
                    context.commit('setBillsKpis', {
                        total_bills: arr.length,
                        total_import: arr.reduce((s, i) => s + (Number(i.price) || 0), 0),
                        total_customers: new Set(arr.map((i) => i.customer_fiscal_id)).size
                    })
                    context.commit('setBillsPagination', { total: arr.length, page: 1, limit: 20, total_pages: 1 })
                }
                return response
            })
            .catch((error) => {
                return error
            })
    },
    async loadCorrectiveBills(context, params) {
        const payload = {
            ...params,
            page: params.page !== undefined ? params.page : 1,
            per_page: params.per_page !== undefined ? params.per_page : 20
        }
        try {
            const response = await api.post('admin/corrective-bills/list', payload)
            if (!response.status) return response
            const meta = response.meta || {}
            const kpis = response.kpis || { total_bills: 0, total_import: 0, total_customers: 0 }
            if (Array.isArray(response.data)) {
                const itemsById = {}
                response.data.forEach((item) => {
                    if (item && item.id != null) itemsById[item.id] = item
                })
                context.commit('setCorrectiveBills', itemsById)
                context.commit('setCorrectiveBillsKpis', kpis)
                context.commit('setCorrectiveBillsPagination', {
                    total: meta.total_bills ?? 0,
                    page: meta.page ?? 1,
                    limit: meta.per_page ?? 20,
                    total_pages: meta.total_pages ?? 0
                })
            } else if (typeof response.data === 'object' && response.data !== null && !Array.isArray(response.data)) {
                const arr = Object.values(response.data)
                context.commit('setCorrectiveBills', response.data)
                context.commit('setCorrectiveBillsKpis', {
                    total_bills: arr.length,
                    total_import: arr.reduce((s, i) => s + Math.abs(Number(i.price) || 0), 0),
                    total_customers: new Set(arr.map((i) => i.customer_fiscal_id)).size
                })
                context.commit('setCorrectiveBillsPagination', { total: arr.length, page: 1, limit: 20, total_pages: 1 })
            }
            return response
        } catch (error) {
            return error
        }
    },
    downloadPDF(context, params) {
        return api
            .post(`admin/bill/list/download/pdf`, params)
            .then((response) => {
                if (response.status) {
                    return response.data
                } else {
                    return response
                }
            })
            .catch((error) => {
                return error
            })
    },
    downloadEXCEL(context, params) {
        return api
            .post(`admin/bill/list/download/excel`, params)
            .then((response) => {
                if (response.status) {
                    return response.data
                } else {
                    return response
                }
            })
            .catch((error) => {
                return error
            })
    },
    downloadXML(context, params) {
        return api
            .post(`admin/bill/list/download/xml`, params)
            .then((response) => {
                if (response.status) {
                    return response.data
                } else {
                    return response
                }
            })
            .catch((error) => {
                return error
            })
    },
    loadFiltersBills(context) {
        return api
            .get(`admin/bill/filters`)
            .then((response) => {
                if (response.status) {
                    context.commit('setBillsFilters', response.data)
                }
                return response
            })
            .catch((error) => {
                return error
            })
    },
    async resendBill(context, { invoiceNumber }) {
        try {
            const response = api.get(`admin/bill/resend/${invoiceNumber}`)
            return response.status
        } catch (error) {
            return error
        }
    },
    async regenerateBill(context, { invoiceNumber }) {
        try {
            const response = await api.get(`admin/bill/regenerate/${invoiceNumber}`)
            context.commit('updateFile', { invoice: invoiceNumber, file: response.data })
            return response.data
        } catch (error) {
            return error
        }
    },
    async cancelBill(context, { invoiceNumber }) {
        try {
            const response = await api.get(`admin/bill/cancel/${invoiceNumber}`)
            context.commit('updateStatus', { invoice: invoiceNumber, status: response.data.status })
            return response.data
        } catch (error) {
            return error
        }
    }
}

const mutations = {
    setBills: (state, value) => {
        state.bills = value
        Vue.set(state, 'bills', value)
    },
    setBillsKpis: (state, value) => {
        state.billsKpis = value || { total_bills: 0, total_import: 0, total_customers: 0 }
        Vue.set(state, 'billsKpis', state.billsKpis)
    },
    setBillsPagination: (state, value) => {
        state.billsPagination = { total: value.total || 0, page: value.page || 1, limit: value.limit || 20 }
        Vue.set(state, 'billsPagination', state.billsPagination)
    },
    setCorrectiveBills: (state, value) => {
        state.correctiveBills = value
        Vue.set(state, 'correctiveBills', value)
    },
    setCorrectiveBillsKpis: (state, value) => {
        state.correctiveBillsKpis = value || { total_bills: 0, total_import: 0, total_customers: 0 }
        Vue.set(state, 'correctiveBillsKpis', state.correctiveBillsKpis)
    },
    setCorrectiveBillsPagination: (state, value) => {
        state.correctiveBillsPagination = { total: value.total || 0, page: value.page || 1, limit: value.limit || 20 }
        Vue.set(state, 'correctiveBillsPagination', state.correctiveBillsPagination)
    },
    setBillsFilters: (state, value) => {
        state.billsFilters = value
        Vue.set(state, 'billsFilters', value)
    },
    setBillsFiltersActive: (state, value) => {
        state.billsFiltersActive = value
        Vue.set(state, 'billsFiltersActive', value)
    },
    updateFile(state, { invoice, file }) {
        if (state.bills[invoice]) {
            state.bills[invoice].file = file
            Vue.set(state.bills, invoice, state.bills[invoice])
        }
    },
    updateStatus(state, { invoice, status }) {
        state.bills[invoice].status = status
        Vue.set(state, 'bills', state.bills)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
